import PropTypes from 'prop-types';
import { GCrossIcon } from '../app/icons/common-icons';

export default function PaymentFailedModal({
  message, onClose, headerText,
}) {
  return (
    <div className="g-modal-window">
      <article className="g-modal-wrapper alternate payment-process">
        <header className="g-modal-head">
          <button type="button" data-testid="close" className="nostyle g-modal-close" onClick={onClose}>
            <GCrossIcon />
          </button>
        </header>
        <section className="g-modal-content ta-center">
          <img
            src="https://assets.setmore.com/common/images/billing/payment-failed.svg"
            alt="payment failed icon"
            className="mb-5"
          />
          <h3 data-testid="headerText" className="mb-2">{headerText || 'Failed to charge your card'}</h3>
          <p data-testid="text" className="tc-primary mb-12">{message || 'Something went wrong with charging your account, please try again.'}</p>
          <div className="mb-2">
            <button data-testid="tryAgain" className="g-btn-primary" onClick={onClose}>Try again</button>
          </div>
        </section>
      </article>
    </div>
  );
}

PaymentFailedModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  tryAgain: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  message: PropTypes.string,
};

PaymentFailedModal.defaultProps = {
  headerText: '',
  message: '',
};
